import { render, staticRenderFns } from "./SigninScreen.vue?vue&type=template&id=5a791d24&scoped=true"
import script from "./SigninScreen.vue?vue&type=script&lang=js"
export * from "./SigninScreen.vue?vue&type=script&lang=js"
import style0 from "./SigninScreen.vue?vue&type=style&index=0&id=5a791d24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a791d24",
  null
  
)

export default component.exports